"use client"

import { useState } from "react"
import { Popover, Button, Select, Modal, message } from "antd"
import { ExclamationCircleOutlined } from "@ant-design/icons"
import TrainerActLogModal from "../../../trainers/atoms/trainer_actlog_modal"
import DeleteBox from "../../../trainers/atoms/delete_box"
import { restApi, message_info } from "../../../../apis"

const LOGIN_STATUS_OPTIONS = [
  { value: 0, label: "로그아웃" },
  { value: 1, label: "로그인중" },
  { value: 2, label: "중복로그인 허용" },
]

const LOGIN_STATUS_LABELS = {
  0: "로그아웃",
  1: "로그인중",
  2: "중복로그인 허용",
}

function TitleComponent(props) {
  return (
    <div
      style={{
        display: "flex",
        height: "4.2rem",
        justifyContetn: "center",
        alignItems: "center",
        background: "#7367F0",
        borderRadius: "10px 10px 0px 0px",
        paddingLeft: 20,
        color: "#FFF",
      }}
    >
      {`트레이너당 메뉴`}
    </div>
  )
}

function ContentComponent(props) {
  const {
    gModal,
    setGModal,
    uuid,
    accountId,
    adminName = "Empty",
    setPopup,
    isValid,
    changeValid,
    changeDelete,
    onTrainerDeleted,
    onTrainerUpdated,
    refreshData,
    data,
  } = props

  // 로그인 상태 변경 실행
  const executeLoginStatusChange = async (newStatus) => {
    try {
      const response = await restApi.patch(`/admin/account/${accountId}/login-status`, {
        loginStatus: newStatus,
      })

      if (response?.data?.message === "OK") {
        message.success("로그인 상태가 변경되었습니다.")
        // 부모 컴포넌트 상태 업데이트
        if (onTrainerUpdated) {
          onTrainerUpdated(accountId, { account_loginStatus: newStatus })
        }
      } else {
        message.error(response?.data?.error?.message || "로그인 상태 변경에 실패했습니다.")
      }
    } catch (err) {
      message.error("로그인 상태 변경에 실패했습니다.")
    }
  }

  // 로그인 상태 변경 핸들러 (확인 모달 표시)
  const handleLoginStatusChange = (newStatus) => {
    const currentStatus = data?.account_loginStatus
    const currentLabel = LOGIN_STATUS_LABELS[currentStatus] || "알 수 없음"
    const newLabel = LOGIN_STATUS_LABELS[newStatus] || "알 수 없음"

    Modal.confirm({
      title: "로그인 상태 변경",
      icon: <ExclamationCircleOutlined />,
      content: (
        <div>
          <p>
            <strong>{adminName}</strong> 트레이너의 로그인 상태를 변경하시겠습니까?
          </p>
          <p style={{ marginTop: 12, color: "#666" }}>
            <span style={{ color: "#999" }}>{currentLabel}</span>
            {" → "}
            <span style={{ color: "#7367F0", fontWeight: 600 }}>{newLabel}</span>
          </p>
          {newStatus === 0 && (
            <p style={{ marginTop: 8, color: "#ff4d4f", fontSize: 12 }}>
              ⚠️ 로그아웃 처리 시 현재 기기 정보와 리프레시 토큰이 초기화됩니다.
            </p>
          )}
        </div>
      ),
      okText: "변경",
      cancelText: "취소",
      onOk: () => executeLoginStatusChange(newStatus),
    })
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* 활동 로그 보기 */}
      <div
        style={{
          display: "flex",
          marginTop: "-0.7rem",
          padding: "0rem 0rem 0rem 0rem",
          borderBottom: "1px solid #DBDADE",
        }}
      >
        <Button
          style={{
            display: "flex",
            width: "100%",
            height: "5.4rem",
            alignItems: "center",
          }}
          type="text"
          shape="default"
          size="middle"
          onClick={(e) => {
            setGModal((prev) => {
              return {
                ...prev,
                show: true,
                component: <TrainerActLogModal trainerName={adminName} {...props} />,
              }
            })
            setPopup(false)
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontFamily: "Public Sans",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "1.5rem",
              lineHeight: "2.2rem",
            }}
          >
            {`활동 로그 데이터 보기`}
          </div>
        </Button>
      </div>

      {/* 활동 정지/활성 */}
      <div
        style={{
          display: "flex",
          padding: "0rem 0rem 0rem 0rem",
          borderBottom: "1px solid #DBDADE",
        }}
      >
        <Button
          style={{
            display: "flex",
            width: "100%",
            height: "5.4rem",
            alignItems: "center",
          }}
          type="text"
          shape="default"
          size="middle"
          onClick={(e) => {
            setGModal((prev) => {
              return {
                ...prev,
                show: true,
                component: (
                  <div style={{ backgroundColor: "#FFF" }}>
                    <DeleteBox
                      id={accountId}
                      title={isValid == "T" ? `${adminName} 트레이너 계정 정지` : `${adminName} 트레이너 계정 활성`}
                      boxTitle={
                        isValid == "T"
                          ? `해당 트레이너 계정을 정지하시겠습니까?`
                          : `해당 트레이너 계정을 활성하시겠습니까?`
                      }
                      boxContents={``}
                      buttonTitle={isValid == "T" ? `활동정지` : "활성"}
                      onClosed={() => {
                        setTimeout(() => {
                          setGModal((prev) => {
                            return {
                              ...prev,
                              show: false,
                            }
                          })
                        }, 500)
                      }}
                      onDeleted={async () => {
                        const response = await restApi
                          .patch(`/admin/trainer/${accountId}?isValid=${isValid == "T" ? "false" : "true"}`, {})
                          .then((v) => {
                            return v?.data
                          })

                        if (response && response.message) {
                          changeValid(isValid)
                          message_info(response.message)
                        } else {
                          message_info(isValid == "T" ? "활동 정지에 실패하였습니다." : "활동에 실패하였습니다.")
                        }

                        setTimeout(() => {
                          setGModal((prev) => {
                            return {
                              ...prev,
                              show: false,
                            }
                          })
                        }, 1000)
                      }}
                    />
                  </div>
                ),
              }
            })
            setPopup(false)
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontFamily: "Public Sans",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "1.5rem",
              lineHeight: "2.2rem",
            }}
          >
            {isValid == "T" ? `활동 정지 시키기` : `활동 승인 하기`}
          </div>
        </Button>
      </div>

      {/* 로그인 상태 변경 */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "1rem 1.2rem",
          borderBottom: "1px solid #DBDADE",
        }}
      >
        <div
          style={{
            fontFamily: "Public Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "1.3rem",
            lineHeight: "2rem",
            color: "#666",
            marginBottom: "0.5rem",
          }}
        >
          {`로그인 상태 변경`}
        </div>
        <Select
          style={{ width: "100%" }}
          size="small"
          value={data?.account_loginStatus}
          onChange={(newStatus) => {
            setPopup(false)
            handleLoginStatusChange(newStatus)
          }}
          options={LOGIN_STATUS_OPTIONS}
          placeholder="상태 선택"
        />
      </div>

      {/* 트레이너 삭제 */}
      <div
        style={{
          display: "flex",
          padding: "0rem 0rem 0rem 0rem",
          borderBottom: "1px solid #DBDADE",
        }}
      >
        <Button
          style={{
            display: "flex",
            width: "100%",
            height: "5.4rem",
            alignItems: "center",
          }}
          type="text"
          shape="default"
          size="middle"
          onClick={(e) => {
            setGModal((prev) => {
              return {
                ...prev,
                show: true,
                component: (
                  <div style={{ backgroundColor: "#FFF" }}>
                    <DeleteBox
                      id={accountId}
                      title={`트레이너 계정 삭제`}
                      boxTitle={`해당 트레이너 계정을 삭제하시겠습니까?`}
                      boxContents={`삭제한 계정에 포함된 데이터(시퀀스/템포/강의)는 밸런스피터 DB로 종속되며, 한번 삭제한 트레이너 계정은 다시 복구할 수 업습니다. 정말 삭제하시겠습니까?`}
                      buttonTitle={`트레이너 계정 삭제`}
                      onClosed={() => {
                        setTimeout(() => {
                          setGModal((prev) => {
                            return {
                              ...prev,
                              show: false,
                            }
                          })
                        }, 500)
                      }}
                      onDeleted={async () => {
                        try {
                          const response = await restApi
                            .delete(`/admin/trainer/${accountId}`, {
                              params: { depth: null },
                            })
                            .then((v) => {
                              console.log("### 삭제 완료")

                              // 삭제 성공 시 부모 컴포넌트의 상태 업데이트
                              if (onTrainerDeleted) {
                                onTrainerDeleted(accountId)
                              }

                              return v && v.data && v.data.payload
                            })

                          changeDelete(isValid)
                          message_info((response && response.message) || "삭제하는데 실패하였습니다.")
                        } catch (error) {
                          console.error("삭제 실패:", error)
                          message_info("삭제하는데 실패하였습니다.")
                        }

                        setTimeout(() => {
                          setGModal((prev) => {
                            return {
                              ...prev,
                              show: false,
                            }
                          })
                        }, 1000)
                      }}
                    />
                  </div>
                ),
              }
            })
            setPopup(false)
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontFamily: "Public Sans",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "1.5rem",
              lineHeight: "2.2rem",
              color: "#DB4437",
            }}
          >
            {`트레이너 삭제하기`}
          </div>
        </Button>
      </div>
    </div>
  )
}

const TrainerPopover = (props) => {
  const component = props.component
  const width = props.width
  const [clicked, setPopup] = useState(false)

  return (
    <Popover
      placement="leftTop"
      title={TitleComponent({ ...props })}
      content={ContentComponent({ ...props, setPopup })}
      overlayStyle={{ width: 240 }}
      overlayInnerStyle={{ padding: 0 }}
      showArrow={false}
      trigger="click"
      open={clicked}
      onOpenChange={(open) => {
        setPopup(open)
      }}
    >
      <Button
        type="link"
        style={{
          display: "flex",
          width,
          flexDirection: "column",
          justifyContetn: "center",
          alignItems: "center",
        }}
      >
        {component}
      </Button>
    </Popover>
  )
}

export default TrainerPopover
